export default {
  drawer: false,
  block: false,
  dialog: { show: false },
  preventRouting: null
}
